import React, { createContext, useContext, useEffect, useState } from "react";

const translations = {
  nl: {
    nav: {
      home: "Home",
      batteries: "Thuisbatterijen",
      solar: "Zonnepanelen",
      chargers: "Laadpalen",
      business: "Zakelijke Oplossing",
      finance: "Duurzaam Financieren",
      how: "Werking",
      install: "Installatie",
      brands: "Merken",
      reviews: "Reviews",
      about: "Over ons",
      faq: "FAQ",
      contact: "Contact",
      cta: "Gratis advies",
    },
    hero: {
      eyebrow: "Premium thuisbatterijen · Nederland",
      title: "Haal meer uit je zonne-energie met een slimme thuisbatterij.",
      subtitle: "Helios Bright installeert premium thuisbatterijen van Tesla, BYD en Huawei. Bespaar tot 70% op je energierekening en wees klaar voor de toekomst zonder salderingsregeling.",
      ctaPrimary: "Bereken jouw besparing",
      ctaSecondary: "Gratis advies aanvragen",
      stat1: "2.500+ klanten",
      stat2: "10 jaar garantie",
      stat3: "5.0 / 5 op Google",
    },
    trust: {
      title: "Vertrouwd door duizenden Nederlandse huishoudens",
      reviews: "Google reviews",
      warranty: "10 jaar garantie",
      certified: "Gecertificeerde installateurs",
      customers: "Tevreden klanten",
    },
    calc: {
      eyebrow: "Besparingscalculator",
      title: "Bereken jouw jaarlijkse besparing",
      subtitle: "3 vragen, direct inzicht. Vul je gegevens in en zie wat een thuisbatterij voor jou oplevert.",
      panels: "Aantal zonnepanelen",
      usage: "Jaarlijks stroomverbruik (kWh)",
      cost: "Huidige energiekosten per maand (€)",
      recommendationLabel: "Advies batterijcapaciteit",
      recommendationHint: "Automatisch berekend op basis van je verbruik en panelen.",
      cta: "Vraag persoonlijke offerte aan",
      results: "Jouw resultaten",
      annualSavings: "Jaarlijkse besparing",
      monthlySavings: "Maandelijkse besparing",
      payback: "Terugverdientijd",
      selfConsumption: "Eigen verbruik",
      co2: "CO₂ besparing per jaar",
      years: "jaar",
      kg: "kg",
    },
    products: {
      eyebrow: "Premium merken",
      title: "Wij installeren alleen de besten.",
      subtitle: "Van Tesla Powerwall tot Huawei Luna2000, wij adviseren en installeren alleen merken die zich bewezen hebben.",
    },
    projects: {
      eyebrow: "Showcase",
      title: "Recent gerealiseerde projecten",
      subtitle: "Een blik op enkele van onze meest recente installaties bij Nederlandse huishoudens.",
    },
    reviews: {
      eyebrow: "Wat klanten zeggen",
      title: "5.0 / 5 op basis van klantbeoordelingen",
    },
    faq: {
      eyebrow: "Veelgestelde vragen",
      title: "Antwoorden op je belangrijkste vragen",
    },
    contact: {
      eyebrow: "Gratis advies",
      title: "Ontvang jouw gratis thuisbatterij-offerte",
      subtitle: "Onze adviseurs nemen binnen 24 uur contact met je op. Geen verplichtingen.",
      trust1: "Gratis advies",
      trust2: "Geen verplichtingen",
      trust3: "Reactie binnen 24 uur",
      name: "Naam",
      email: "E-mailadres",
      phone: "Telefoonnummer",
      message: "Bericht (optioneel)",
      submit: "Ontvang mijn offerte",
      success: "Bedankt! We nemen binnen 24u contact op.",
      error: "Er ging iets mis. Probeer het opnieuw.",
    },
    footer: {
      tagline: "De toekomst van energie. Vandaag in jouw huis.",
      services: "Diensten",
      company: "Bedrijf",
      legal: "Juridisch",
      copyright: "© 2025 Helios Bright B.V. Alle rechten voorbehouden.",
    },
  },
  en: {
    nav: {
      home: "Home",
      batteries: "Home Batteries",
      solar: "Solar Panels",
      chargers: "EV Chargers",
      business: "Business Solutions",
      finance: "Sustainable Financing",
      how: "How it works",
      install: "Installation",
      brands: "Brands",
      reviews: "Reviews",
      about: "About",
      faq: "FAQ",
      contact: "Contact",
      cta: "Free advice",
    },
    hero: {
      eyebrow: "Premium home batteries · Netherlands",
      title: "Get more from your solar energy with a smart home battery.",
      subtitle: "Helios Bright installs premium home batteries from Tesla, BYD and Huawei. Save up to 70% on your energy bill and be ready for the future without net metering.",
      ctaPrimary: "Calculate your savings",
      ctaSecondary: "Get free advice",
      stat1: "2,500+ customers",
      stat2: "10 year warranty",
      stat3: "5.0 / 5 on Google",
    },
    trust: {
      title: "Trusted by thousands of Dutch households",
      reviews: "Google reviews",
      warranty: "10 year warranty",
      certified: "Certified installers",
      customers: "Happy customers",
    },
    calc: {
      eyebrow: "Savings calculator",
      title: "Calculate your annual savings",
      subtitle: "3 quick questions. Enter your details and instantly see what a home battery delivers.",
      panels: "Number of solar panels",
      usage: "Annual electricity usage (kWh)",
      cost: "Current monthly energy cost (€)",
      recommendationLabel: "Recommended battery capacity",
      recommendationHint: "Automatically based on your usage and panels.",
      cta: "Request a personal quote",
      results: "Your results",
      annualSavings: "Annual savings",
      monthlySavings: "Monthly savings",
      payback: "Payback time",
      selfConsumption: "Self consumption",
      co2: "CO₂ savings per year",
      years: "years",
      kg: "kg",
    },
    products: {
      eyebrow: "Premium brands",
      title: "We only install the best.",
      subtitle: "From Tesla Powerwall to Huawei Luna2000, we only recommend proven brands.",
    },
    projects: {
      eyebrow: "Showcase",
      title: "Recently completed projects",
      subtitle: "A look at some of our most recent installations at Dutch homes.",
    },
    reviews: {
      eyebrow: "What customers say",
      title: "5.0 / 5 based on customer reviews",
    },
    faq: {
      eyebrow: "Frequently asked questions",
      title: "Answers to your key questions",
    },
    contact: {
      eyebrow: "Free advice",
      title: "Get your free home battery quote",
      subtitle: "Our advisors will contact you within 24 hours. No commitments.",
      trust1: "Free advice",
      trust2: "No commitments",
      trust3: "Response within 24 hours",
      name: "Name",
      email: "Email address",
      phone: "Phone number",
      message: "Message (optional)",
      submit: "Get my quote",
      success: "Thanks! We'll be in touch within 24h.",
      error: "Something went wrong. Please try again.",
    },
    footer: {
      tagline: "The future of energy. Today in your home.",
      services: "Services",
      company: "Company",
      legal: "Legal",
      copyright: "© 2025 Helios Bright B.V. All rights reserved.",
    },
  },
};

const LangCtx = createContext({ lang: "nl", setLang: () => {}, t: translations.nl });

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("hb_lang") || "nl");
  useEffect(() => { localStorage.setItem("hb_lang", lang); }, [lang]);
  const t = translations[lang] || translations.nl;
  return <LangCtx.Provider value={{ lang, setLang, t }}>{children}</LangCtx.Provider>;
};

export const useLang = () => useContext(LangCtx);
